<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <tt-input ttLabel="searchtext" ttFocus [(ttModel)]="searchText" ttShowClearButton></tt-input>
    </tt-card>

    <tt-list [ttData]="itemsListLabours" ttBackStyle [ttGoto]="false" [ttFilter]="searchText" (ttClick)="goBackToPrevious($event)"></tt-list>
</tt-page>
